module.exports = __webpack_public_path__ + "files/f4c3270b2710ca9e0d537bea35ca5f06.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_AMS-Regular.woff2
// module id = 1165
// module chunks = 76